import type { FunctionComponent } from "react";
import FavoriteGroupAdminPartial from "../../../partials/admin/favourites/favorite-group.admin.partials";

export const FavouriteGroupAdminScreen: FunctionComponent = () => {
    return <FavoriteGroupAdminPartial />;
};
